/**
 * Created by cz on 2020/5/6.
 */
import qs from 'qs'
import Vue from 'vue'
import axios from 'axios'
import router from '../router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(ElementUI)

// 请求头设置
axios.interceptors.request.use(config => {
  config.headers.Authorization = sessionStorage.getItem('authorization') || ''
  return config
}, err => {
  return Promise.reject(err)
})

axios.interceptors.response.use(response => {
  if (response.data.code !== '0') {
    errorBack(response.data.code, response.data.msg)
    return false
  } else {
    return response
  }
}, err => {
  return Promise.reject(err)
})

// 接口返回的错误处理
let errorBack = (code, msg) => {
  let that = new Vue()
  switch (code) {
    case '-1':
      that.$message.error(msg)
      break
    case '-6':
      router.push({
        path: '/login'
      })
      break
  }
}

let api = '/dxyd' // 接口路径标识，比如: /qrzd。没有就是''

export default {
  // 首页
  homePage (params) {
    let param = qs.stringify(params)
    return axios.get(`${api}/api/homepage/home?${param}`)
  },
  child (params) {
    let param = qs.stringify(params)
    return axios.get(`${api}/api/trend/child?${param}`)
  },
  detail (id) {
    return axios.get(`${api}/api/trend/detail/${id}`)
  },
  pDetail (id) {
    return axios.get(`${api}/api/person/detail/${id}`)
  },
  dxdt (params) {
    let param = qs.stringify(params)
    return axios.get(`${api}/api/trend/dxdt?${param}`)
  },
  hdss (params) {
    let param = qs.stringify(params)
    return axios.get(`${api}/api/trend/hdss?${param}`)
  },
  jypx (params) {
    let param = qs.stringify(params)
    return axios.get(`${api}/api/trend/jypx?${param}`)
  },
  dxfc (params) {
    let param = qs.stringify(params)
    return axios.get(`${api}/api/person/dxfc?${param}`)
  },
  dxzb (params) {
    let param = qs.stringify(params)
    return axios.get(`${api}/api/trend/dxzb?${param}`)
  },
  comment (params) {
    let param = qs.stringify(params)
    return axios.get(`${api}/api/comment/list?${param}`)
  },
  commentSave (params) {
    return axios.post(`${api}/api/comment/save`, params)
  },
  downloadList (params) {
    let param = qs.stringify(params)
    return axios.get(`${api}/api/file/list?${param}`)
  },
  downloadFile (fileId) {
    return `${api}/api/file/download/file?id=${fileId}`
  },
  websiteList () {
    return axios.get(`${api}/api/website/list`)
  }
}



// WEBPACK FOOTER //
// ./src/api/api.js